import { useMutation } from "urql";

import { UnFreezeLimitDocument } from "../../../graphql/generated.ts";

export const useUnFreezeLimit = () => useMutation(UnFreezeLimitDocument);
